import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { iValidatedControl } from '../iValidatedControl';
import { BaseCustomControl } from '../baseCustomControl';
import { ListItem } from '../../../../../../../../libs/Shared/components/model/listItem';

@Component({
  selector: 'app-label-input',
  templateUrl: './label-input.component.html',
  providers: [
    // see https://blog.thoughtram.io/angular/2016/07/27/custom-form-controls-in-angular-2.html
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LabelInputComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class LabelInputComponent
  extends BaseCustomControl
  implements ControlValueAccessor, iValidatedControl
{
  @Input() allowNewTags: boolean = true;
  @Input() getData!: (message: string) => ListItem[]; // the function responsible for returning a filtered list of options
  @Input() minimumTagCount: number = 0;
  @Input() maximumTagCount: number = 0;

  @Output() onselected = new EventEmitter<ListItem>();
  @Output() ondeleted = new EventEmitter<ListItem>();
  @Output() onblur = new EventEmitter<ListItem[]>();

  filteredSuggestions: ListItem[] = [];
  selectedTags: ListItem[] = [];
  currentInput: string = '';
  activeIndex: number = -1;

  // // Some Angular magic to tie our bound value to the ngModel:
  // onChange:any = () => {};
  // onTouch:any = () => {};

  // writeValue(value: ListItem[]): void {
  //     this.selectedTags = value;
  //     this.onValueBound();
  // }

  // registerOnChange(fn: any): void {
  //     this.onChange = fn;
  // }

  // registerOnTouched(fn: any): void {
  //     this.onTouch = fn;
  // }

  // protected onValueBound():void {
  // }
  // // End Angular magic

  public validate(): boolean {
    this.isValid = true;
    this.validationMsg = '';

    if (this.required && this.selectedTags.length == 0) {
      this.isValid = false;
      this.validationMsg = 'required';
    } else if (this.selectedTags.length < this.minimumTagCount) {
      this.isValid = false;
      this.validationMsg = 'required';
    }

    return this.isValid;
  }

  override ngOnInit() {
    super.ngOnInit();

    if (!this.getData) {
      throw 'no endpoint for tag input';
    }
  }

  public getSelectedTags(): ListItem[] {
    return this.selectedTags;
  }

  onInput(event: Event): void {
    const input = (event.target as HTMLInputElement).value;
    this.currentInput = input;

    if (input) {
      this.getSuggestions(input);
    } else {
      this.filteredSuggestions = [];
    }

    this.activeIndex = -1; // Reset active index
  }

  override handle_onBlur(e: FocusEvent) {
    this.validate();
    this.resetSuggestions();
    this.onblur.emit(this.selectedTags);
  }

  getSuggestions(input: string) {
    if (this.getData) {
      this.filteredSuggestions = this.getData(input);
    }
  }

  isTagAlreadySelected(tag: string): boolean {
    for (let i = 0; i < this.selectedTags.length; i++) {
      if (this.selectedTags[i].name == tag) {
        return true;
      }
    }
    return false;
  }

  getTagByName(name: string): ListItem | undefined {
    for (let i = 0; i < this.filteredSuggestions.length; i++) {
      if (this.filteredSuggestions[i].name == name) {
        return this.filteredSuggestions[i];
      }
    }
    return undefined;
  }

  addTag(): void {
    if (
      this.maximumTagCount > 0 &&
      this.selectedTags.length == this.maximumTagCount
    ) {
      return;
    }

    if (
      this.currentInput.trim() &&
      !this.isTagAlreadySelected(this.currentInput)
    ) {
      let tag = this.getTagByName(this.currentInput.trim());

      if (tag) {
        this.selectedTags.push();
      } else if (this.allowNewTags) {
        tag = new ListItem({ id: '', name: this.currentInput.trim() });
        this.selectedTags.push(tag);
      }

      if (this.onselected && tag) {
        this.onselected.emit(tag);
      }
    }

    this.currentInput = '';
    this.filteredSuggestions = [];
  }

  selectSuggestion(suggestion: ListItem): void {
    if (
      this.maximumTagCount > 0 &&
      this.selectedTags.length == this.maximumTagCount
    ) {
      return;
    }

    if (!this.isTagAlreadySelected(suggestion.name)) {
      this.selectedTags.push(suggestion);

      if (this.onselected) {
        this.onselected.emit(suggestion);
      }
    }

    this.currentInput = '';
    this.filteredSuggestions = [];
  }

  removeTag(tag: string): void {
    let tagToRemove = this.getTagByName(tag);

    for (let i = 0; i < this.selectedTags.length; i++) {
      if (this.selectedTags[i].name == tag) {
        this.selectedTags.splice(i, 1);
        break;
      }
    }

    this.validate();

    if (this.ondeleted) {
      this.ondeleted.emit(tagToRemove);
    }
  }

  resetSuggestions(): void {
    setTimeout(() => {
      this.filteredSuggestions = [];
    }, 200); // Slight delay to allow for selection click
  }
}
